import useEditEmailAddressController, { OnDone } from './edit-email-address.controller';
import ModalUpdateEmail from './modals/modal-update-email/modal-update-email';
import ModalVerifyEmail from './modals/modal-verify-email/modal-verify-email';

type EditEmailAddressProps = {
  onDone: OnDone;
};

export default function EditEmailAddress({ onDone }: EditEmailAddressProps) {
  const { modalToShow, handleCancelEditEmail, newEmail, handleNewEmailEntered, handleEmailChanged } =
    useEditEmailAddressController(onDone);

  return modalToShow === 'update-email' ? (
    <ModalUpdateEmail isOpen onCloseClick={handleCancelEditEmail} onDone={handleNewEmailEntered} />
  ) : (
    <ModalVerifyEmail isOpen onCloseClick={handleCancelEditEmail} newEmail={newEmail} onDone={handleEmailChanged} />
  );
}
